import { render } from "./EditPlayerForm.vue?vue&type=template&id=35001a56&scoped=true"
import script from "./EditPlayerForm.vue?vue&type=script&lang=js"
export * from "./EditPlayerForm.vue?vue&type=script&lang=js"

import "./EditPlayerForm.vue?vue&type=style&index=0&id=35001a56&scoped=true&lang=css"

import exportComponent from "C:\\BiggerInside\\Protocol223-Portal\\portal\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35001a56"]])

export default __exports__